module.exports = __webpack_public_path__ + "img/m6.b25d7a5a.svg";